import { GridCellProps } from '@progress/kendo-react-grid';
import styled from 'styled-components';

type Props = {
  className?: string;
  e: GridCellProps;
};

const ShowRiderGradeCell = ({ className, e,  }: Props) => {
  const data = e?.dataItem;
  return (
    <td className={className ?? ''}>
      <Wrapper>{data?.grade}</Wrapper>
    </td>
  );
};

export default ShowRiderGradeCell;
const Wrapper = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  max-width: 70px;
  display: block;
`;
